const recoverUploadObjectId = (partialUpload, settings) => ({
  data: {
    id: partialUpload.id,
    token: settings.authToken || partialUpload.authToken,
  },
});

export default recoverUploadObjectId;
